import { EcommerceAPI } from "../Client";

const webhookUrl = (tenant) => `/webhook/facebook/${encodeURIComponent(tenant)}`;

export const verifyFacebookWebhookApi = (tenant, { mode, verifyToken, challenge }) =>
  EcommerceAPI.get(webhookUrl(tenant), {
    params: { "hub.mode": mode, "hub.verify_token": verifyToken, "hub.challenge": challenge },
    responseType: "text",
  });

// Pass the original serialized JSON body and its signature unchanged.
export const receiveFacebookWebhookApi = (tenant, body, signature) =>
  EcommerceAPI.post(webhookUrl(tenant), body, {
    headers: {
      "Content-Type": "application/json",
      ...(signature ? { "X-Hub-Signature-256": signature } : {}),
    },
    transformRequest: [(data) => data],
    responseType: "text",
  });

// body: { recipientId: string, text: string }
export const sendFacebookMessageApi = (body) =>
  EcommerceAPI.post("/facebook/messages", body);

export const getFacebookPostsApi = ({ limit = 20, after } = {}) =>
  EcommerceAPI.get("/admin/social/facebook/posts", {
    params: { limit, ...(after ? { after } : {}) },
  });
